<template>
    <b-container class="mt-2" fluid>
        <b-row>
            <b-col md="7">
                <form-textarea v-model="details.client.note" :rows="15" />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <b-button @click="save" variant="primary">Save</b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import api from '../../../../api';
import { ADMIN_SUBSCRIBER_COMMENTS } from '../../../../endpoints';
import { formatResponseError } from '../../../../utils/api';
import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
export default {
    components: {
        FormTextarea,
    },
    inject: ['userId'],
    data() {
        return {
            note: null,
        };
    },
    computed: {
        ...mapGetters('adminSubscriberAccount', ['details']),
    },
    methods: {
        ...mapActions('adminSubscriberAccount', ['fetchDetails']),
        async save() {
            try {
                this.$parent.$emit('busy', true);
                await api.post(
                    `${ADMIN_SUBSCRIBER_COMMENTS(this.userId)}save/`,
                    {
                        note: this.details.client.note,
                    }
                );
                await this.fetchDetails({
                    id: this.userId,
                });
                this.successToast({ text: 'Note was successfully saved' });
            } catch (e) {
                const { generic } = formatResponseError(e);

                if (generic) {
                    this.errorToast({ text: generic });
                } else {
                    this.errorToast({ text: 'Could not save note' });
                }
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
    },
};
</script>

<style>
</style>